<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'PageNotFound',
    computed: {
      ...mapState('auth', { activeUser: 'user' }),
    },
    beforeRouteEnter(to, from, next) {
      window.previousRoute = from
      next()
    },
    created() {
      this.getRoutesForUser(this.activeUser)
    },
    destroyed() {
      this.clearError()
    },
    methods: {
      ...mapActions('app', ['clearError']),
      ...mapActions('auth', ['getRoutes']),
      getRoutesForUser(user) {
        // update routes
        user && this.getRoutes()
      },
      routeBack() {
        const route = window.previousRoute || { name: 'dashboard' }
        this.$router.push(route)
      },
    },
  }
</script>
